/**
 * 任务调度设置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class productSuiteManageService {
  //基础平台微服务api
  prefix: string = environment.seekerWebAPI;

  constructor(
    private http: SwHttpClientService,
    private httpClient: HttpClient,
  ) {
  }

  //#region kit 产品套件接口
  //查询
  queryPageList(param) {
    const url = this.prefix + 'product/queryKitPageList';
    return this.http.Post(url, param);
  }

  //新增
  save(param) {
    const url = this.prefix + 'product/saveKit';
    return this.http.Post(url, param);
  }


  //修改
  update(param) {
    const url = this.prefix + 'product/updateById';
    return this.http.Post(url, param);
  }

  //查询
  queryById(param) {
    const url = this.prefix + 'product/queryKitById';
    return this.http.Post(url, param);
  }

  //删除
  delete(param) {
    const url = this.prefix + 'product/deleteBatch';
    return this.http.Post(url, param);
  }

  //关联信息保存
  saveOrDelete(param) {
    const url = this.prefix + 'product/saveOrDeleteKitProduct';
    return this.http.Post(url, param);
  }

  //关联信息查询
  queryByFk(param) {
    const url = this.prefix + 'product/queryKitProductByFk';
    return this.http.Post(url, param);
  }
  //#endregion

}
